import type { ErrorComponentProps } from "@tanstack/react-router"
import { OctagonAlert } from "lucide-react"
import { useEffect } from "react"
import { AppLink } from "#/components/app-link"
import { Button, buttonVariants } from "#/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "#/components/ui/card"
import { trackEvent } from "#/lib/posthog"
import { Sentry } from "#/lib/sentry"

export function RouteError({ error, reset }: ErrorComponentProps) {
	useEffect(() => {
		Sentry.captureException(error)
		trackEvent("error_boundary_triggered", {
			error_message: error.message,
			route_path: window.location.pathname,
		})
	}, [error])

	return (
		<div className="flex min-h-[50vh] items-center justify-center p-6">
			<Card className="w-full max-w-md">
				<CardHeader className="items-center text-center">
					<OctagonAlert className="size-10 text-severe" />
					<CardTitle>Something went wrong</CardTitle>
				</CardHeader>
				<CardContent className="text-center">
					<p className="text-sm text-muted-foreground">
						{error.message || "An unexpected error occurred."}
					</p>
				</CardContent>
				<CardFooter className="justify-center gap-3">
					<Button variant="outline" onClick={() => reset()}>
						Try Again
					</Button>
					<AppLink to="/stonelog/dashboard" className={buttonVariants({ variant: "ghost" })}>
						Go to Dashboard
					</AppLink>
				</CardFooter>
			</Card>
		</div>
	)
}
